"use client"

import * as React from "react"
import { motion, useReducedMotion, type Variants } from "motion/react"

type Direction = "up" | "down" | "left" | "right"

interface FadeInProps {
	children: React.ReactNode
	className?: string
	delay?: number
	direction?: Direction
	viewport?: {
		once?: boolean
		margin?: string
	}
}

const directionVariants: Record<Direction, Variants> = {
	up: {
		hidden: { opacity: 0, y: 30 },
		visible: { opacity: 1, y: 0 },
	},
	down: {
		hidden: { opacity: 0, y: -30 },
		visible: { opacity: 1, y: 0 },
	},
	left: {
		hidden: { opacity: 0, x: 30 },
		visible: { opacity: 1, x: 0 },
	},
	right: {
		hidden: { opacity: 0, x: -30 },
		visible: { opacity: 1, x: 0 },
	},
}

export function FadeIn({
	children,
	className,
	delay = 0,
	direction = "up",
	viewport = { once: true, margin: "-50px" },
}: FadeInProps) {
	const shouldReduceMotion = useReducedMotion()
	const variants = directionVariants[direction]

	return (
		<motion.div
			className={className}
			variants={shouldReduceMotion ? { hidden: {}, visible: {} } : variants}
			initial="hidden"
			whileInView="visible"
			viewport={{
				once: viewport.once,
				margin: viewport.margin,
			}}
			transition={{
				duration: 0.5,
				delay: delay / 1000,
				ease: [0.25, 0.1, 0.25, 1],
			}}
		>
			{children}
		</motion.div>
	)
}
